export const loginPath = "/user/login";
export const registerPath = "/user/register";
export const otpPath = "/user/otp";
export const setPasswordPath = "/user/set-password";
